// John Eldhose 201800604
import React, { Component } from 'react';
import { Button, Checkbox, Collapse, Dialog, FormControlLabel, Grid, IconButton, MenuItem, Paper, Radio, Snackbar, Switch, TextField, Toolbar, Typography } from '@material-ui/core';
import { AddBox, Cancel, Close, DeleteForever, Edit, Send } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import ReactTable from 'react-table';
import countries from '../lib/countries';
import { getAccount } from '../../Api/getAccount';
import { getAddress } from '../../Api/getAddress';
import { getContact } from '../../Api/getContact';
import { getDealers } from '../../Api/getDealers';
import { addAddress } from '../../Api/addAddress';
import { addContact } from '../../Api/addContact';
import { updateAccount } from '../../Api/updateAccount';
import { deleteAddress } from '../../Api/deleteAddress';
import { deleteContact } from '../../Api/deleteContact';
import { updateAddress } from '../../Api/updateAddress';
import { updateContact } from '../../Api/updateContact';

const Tables = {
  'Address': [
    {Header: "Address", accessor: "ADDRESS1"},
    {Header: "City", accessor: "CITY"},
    {Header: "State", accessor: "STATE"},
    {Header: "Zip", accessor: "POSTALCODE", width: 65},
    {Header: "Country", accessor: "COUNTRY"},
    {id: "primary", Header: "Primary", accessor: (row) => {
      if(row.PRIMARYBILLING === 'T' && row.PRIMARYSHIPPING === 'T')
        return 'Bill/Ship';
      else if(row.PRIMARYBILLING === 'T')
        return 'Billing';
      else if(row.PRIMARYSHIPPING === 'T')
        return 'Shipping';
      else
        return '';
    }, width: 80}
  ],
  'Team': [{
    Header: "Users",
    columns: [
      {Header: "First Name", accessor: "FIRSTNAME"},
      {Header: "Last Name", accessor: "LASTNAME"},
      {Header: "Work Phone", accessor: "WORKPHONE", width: 100},
      {Header: "Email", accessor: "EMAIL"},
      {id: "contact", Header: 'Contact Type', accessor: (row) => {
        if(row.TYPE.includes('Invoice') && row.TYPE.includes('Maintenance'))
          return 'Invoice/Maintenance';
        else if(row.TYPE.includes('Invoice'))
          return 'Invoice';
        else if(row.TYPE.includes('Maintenance'))
          return 'Maintenance';
        else
          return '';
      }}
  ]}, {
    Header: "Portal",
    columns: [
      {id: "TYPE", Header: "Access", accessor: (type) => {
        return (
          (
            type.TYPE.includes('Invoice') ||
            type.TYPE.includes('Maintenance')
          ) ? 'Yes' : ''
        )
      }, width: 60, style: { textAlign: 'center' }}
    ]}
  ]
};
const Fields = {
  'Address': [
    {name: "ADDRESS1", label: "Address", type: "t"},
    {name: "ADDRESS2", label: "Address 2", type: "t", required: false},
    {name: "CITY", label: "City", type: "t"},
    {name: "STATE", label: "State/County", type: "t"},
    {name: "POSTALCODE", label: "Zip/Post Code", type: "t"},
    {name: "COUNTRY", label: "Country", type: "d"},
    {name: "PRIMARYBILLING", label: "Primary Billing", type: "r"},
    {name: "PRIMARYSHIPPING", label: "Primary Shipping", type: "r"}
  ],
  'Team': [
    {name: "TITLE", label: "Title", type: "t"},
    {name: "FIRSTNAME", label: "First Name", type: "t"},
    {name: "LASTNAME", label: "Last Name", type: "t"},
    {name: "WORKPHONE", label: "Work Phone", type: "t"},
    {name: "EMAIL", label: "Email", type: "t"},
    {name: "TYPE", label: "Invoice", type: "c"},
    {name: "TYPE", label: "Maintenance", type: "c"},
    {name: "ISPRIMARY", label: "Primary Contact", type: "r"}
  ]
};

class AccountDetailsTeam extends Component {

  state = {
    Account: [],
    Addressloading: true,
    Address: [],
    Dealers: [],
    Dialog: '',
    Teamloading: true,
    Team: [],
    data: {},
    dataError: {},
    updateError: '',
    dealerid: ''
  };
  componentWillMount() {
    getAccount()
      .then((acc) => {
        if(acc['status'] === 'true')
          this.setState({ Account: acc['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
    getAddress()
      .then((add) => {
        if(add['status'] === 'true') {
          this.setState({ Address: add['data'] });
          this.setState({ Addressloading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      })
    getContact()
      .then((con) => {
        if(con['status'] === 'true') {
          this.setState({ Team: con['data'] });
          this.setState({ Teamloading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      })
    getDealers()
      .then((dea) => {
        if(dea['status'] === 'true') {
          this.setState({ Dealers: dea['data'] });
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleCloseDialog = () => {
    this.setState({ Dialog: '' });
  }
  handleUserInput = (e, state, id) => {
    var data = this.state['data'];
    data[e.target.name] = e.target.value;
    var dataError = this.state.dataError;
    dataError[e.target.name] = false;
    this.setState({ Dialog: this.buildProductDetail(state, id) });
  }
  handleChange = (e, state, id) => {
    var data = this.state['data'];
    data[e.target.name] = e.target.value;
    this.setState({ Dialog: this.buildProductDetail(state, id) });
  }
  handleSwitch = (e, state, id) => {
    var data = this.state['data'];
    data[e.target.name] = (data[e.target.name] === 'T') ? 'F' : 'T';
    this.setState({ Dialog: this.buildProductDetail(state, id) });
  }
  handleCheckBox = (e, state, id) => {
    var data = this.state['data'];
    var tmp = [];
    if(e.target.checked && data[e.target.value].indexOf(e.target.name) < 0) {
      if(data[e.target.value].trim() === '')
        data[e.target.value] = e.target.name;
      else {
        tmp = data[e.target.value].split(', ');
        var order = ['Invoice', 'Maintenance']
        tmp.splice(order.indexOf(e.target.name), 0, e.target.name);
        data[e.target.value] = tmp.join(', ')
      }
      this.setState({ Dialog: this.buildProductDetail(state, id) });
    }
    else if (!e.target.checked && data[e.target.value].indexOf(e.target.name) > -1) {
      if(data[e.target.value].trim() === e.target.name)
        data[e.target.value] = '';
      else {
        tmp = data[e.target.value].split(', ');
        tmp.splice(tmp.indexOf(e.target.name), 1);
        data[e.target.value] = tmp.join(', ')
      }
      this.setState({ Dialog: this.buildProductDetail(state, id) });
    }
  }
  dealerDialog = (did, dealers, handleChange, handleSave) => {
    return (
      <div>
        <div style={{ textAlign: 'right', background: '#silver' }}>
          <IconButton onClick={this.handleCloseDialog}>
            <Close />
          </IconButton>
        </div>
        <Paper style={{ padding: '20px' }}>
          <div style={{ paddingTop: '2px', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '10px', border: '1px silver solid' }}>
            <TextField
              select
              required={true}
              fullWidth
              label="Dealer"
              value={did}
              onChange={handleChange}
              margin="normal"
              helperText="Pick a dealer from dropdown above to change dealer selection"
            >
              {dealers.map(d => (
                <MenuItem key={d.ACCOUNTID} value={d.ACCOUNTID}>
                  {d.ACCOUNT + '; ' + d.MAINPHONE + '; ' + d.EMAIL}
                </MenuItem>
              ))}
            </TextField>
            <Toolbar>
              <Button
                color='secondary'
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleCloseDialog}
              >
                <FormattedMessage
                  id='Cancel'
                  defaultMessage='Cancel'
                />&nbsp;
                <Cancel />
              </Button>
              <div style={{ flex: 1 }} />
              <Button
                color='primary'
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={handleSave}
              >
                <FormattedMessage
                  id='Save'
                  defaultMessage='Save'
                />&nbsp;
                <Send />
              </Button>
            </Toolbar>
          </div>
        </Paper>
      </div>
    );
  }
  handleDealerDialog = (did) => {
    this.setState({ Dialog: this.dealerDialog(
      did, this.state.Dealers, (e) => {
        this.handleDealerDialog(e.target.value);
      }, () => {
        var account = this.state.Account;
        if(did !== account.dealerid) {
          for(var i = 0; i < this.state.Dealers.length; i++)
            if(did === this.state.Dealers[i].ACCOUNTID)
              break;
          if(i < this.state.Dealers.length) {
            updateAccount({
              dealerid: did, dealer: this.state.Dealers[i].ACCOUNT,
              dealerphone: this.state.Dealers[i].MAINPHONE,
              dealeremail: this.state.Dealers[i].EMAIL
            }, {
              dealerid: account.dealerid, dealer: account.dealer,
              dealerphone: account.dealerphone,
              dealeremail: account.dealeremail
            })
              .then((acc) => {
                if(acc.status === 'true') {
                  account.dealerid = did;
                  account.dealer = this.state.Dealers[i].ACCOUNT;
                  account.dealerphone = this.state.Dealers[i].MAINPHONE;
                  account.dealeremail = this.state.Dealers[i].EMAIL;
                  this.setState({ Account: account });
                }
                else
                  this.setState({ updateError: 'Failed to update the dealer setting' });
              })
              .catch((error) => { console.log(error); })
          }
        }
        this.handleCloseDialog();
      }
    ) });
  }
  buildFields = (state, id) => {
    return (
      Fields[state].map((field) => {
        switch (field['type']) {
          case 'c':
            return (
              <FormControlLabel
                key={field['label']}
                control={
                  <Checkbox
                    name={field['label']}
                    checked={(this.state['data'][field['name']].indexOf(field['label']) > -1)}
                    value={field['name']}
                    onChange={(e) => this.handleCheckBox(e, state, id)}
                  />
                }
                label={(field['label'] === 'Invoice') ? <div dangerouslySetInnerHTML={{ __html: 'Invoice/<br>Send Quote'}} /> : (field['label'] === 'Maintenance') ? <div dangerouslySetInnerHTML={{ __html: 'Maintenance/<br>Service User'}} /> : field['label']}
              />
            );
          case 'd':
            return (
              <TextField
                key={field['name']}
                select
                required={
                  typeof field['required'] === 'undefined' || field['required']
                }
                fullWidth
                name={field['name']}
                label={field['label']}
                value={this.state['data'][field['name']]}
                onChange={(e) => this.handleUserInput(e, state, id)}

                margin="normal"
              >
                {countries.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            );
          case 'r':
            return (
              <FormControlLabel
                key={field['name']}
                control={
                  <Radio
                    name={field['name']}
                    checked={(this.state['data'][field['name']] === 'T')}
                    value={this.state['data'][field['name']]}
                    color="primary"
                    onChange={(e) => this.handleSwitch(e, state, id)}
                  />
                }
                label={field['label']}
              />
            );
          case 's':
            return (
              <FormControlLabel
                key={field['name']}
                control={
                  <Switch
                    name={field['name']}
                    checked={(this.state['data'][field['name']] === 'T')}
                    value={this.state['data'][field['name']]}
                    color="primary"
                    disabled={(id !== 'add' && this.state['data'][field['name']] === 'T')}
                    onChange={(e) => this.handleSwitch(e, state, id)}
                  />
                }
                label={field['label']}
              />
            );
          case 't':
            return (
              <TextField
                key={field['name']}
                required={typeof field['required'] === 'undefined' || field['required']}
                fullWidth
                name={field['name']}
                label={field['label']}
                value={this.state['data'][field['name']]}
                onChange={(e) => this.handleUserInput(e, state, id)}
                error={this.state['dataError'][field['name']]}
              />
            );
          default:
            return (
              <div key={field['name']}>
                {field['label']} {this.state['data'][field['name']]}
              </div>
            );
        }
      })
    );
  }
  deleteButton = (id) => {
    if(id === 'add')
      return;
    return (
      <Button
        color='secondary'
        variant="outlined"
        style={{ textTransform: 'none' }}
        onClick={this.handleClickDelete}
      >
        <FormattedMessage
          id='Delete'
          defaultMessage='Delete'
        />&nbsp;
        <DeleteForever />
      </Button>
    );
  }
  buildProductDetail = (state, id) => {
    return (
      <div>
        <div style={{ textAlign: 'right', background: '#silver' }}>
          <IconButton onClick={this.handleCloseDialog}>
            <Close />
          </IconButton>
        </div>
        <Paper style={{ padding: '20px' }}>
          <div style={{ paddingTop: '2px', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '10px', border: '1px silver solid' }}>
            {this.buildFields(state, id)}
            <Collapse in={(this.state.Account.CONTACTID === this.state.data.CONTACTID && this.state.data.TYPE === '')}>
              <Paper elevation={4}>
                <font color='red'>Warning: This will remove your access to Carlson account details</font>
              </Paper>
            </Collapse>
            <Typography variant="caption" align='center'>
              <table><tbody>
               <tr>
                <td align='left'>
                  {(state === 'Team') ? 'Invoice & Maintenance give user access to Carlson account details' : ''}
                </td>
                <td align='right'>
                  To set "not" as primary, please set another one as primary
                </td>
               </tr>
              </tbody></table>
            </Typography>
            <Toolbar>
              {this.deleteButton(id)}
              <div style={{ flex: 1 }} />
              <Button
                color='primary'
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickSave}
              >
                <FormattedMessage
                  id='Save'
                  defaultMessage='Save'
                />&nbsp;
                <Send />
              </Button>
            </Toolbar>
          </div>
        </Paper>
      </div>
    );
  }
  ProductDetail = (state, id) => {
    var data = this.state['data'];
    var dataError = this.state['dataError'];
    for(var key in data) {
      delete data[key];
    }
    if(state === 'Address') {
      data['ADDRESSID'] = (id === 'add') ? id : this.state[state][id]['ADDRESSID'];
//      data['entity'] = this.state[state][id]['entity'];
//      data['entityid'] = this.state[state][id]['entityid'];
    }
    else if(state === 'Team') {
      data['CONTACTID'] = (id === 'add') ? id : this.state[state][id]['CONTACTID'];
//      data['DONOTSOLICIT'] = (id === 'add') ? 'F' : this.state[state][id]['DONOTSOLICIT'];
    }
    data['state'] = state;
    data['id'] = id;
    Fields[state].map((field) => {
      if(id === 'add')
        data[field['name']] = '';
      else
        data[field['name']] = this.state[state][id][field['name']];
      dataError[field['name']] = false;
      return true;
    });
    this.setState({ Dialog: this.buildProductDetail(state, id) });
  }
  handleOpenDialog = (state, id) => e => {
    this.ProductDetail(state, id);
  }
  handleClickSave = () => {
    var id = (typeof this.state.data.id !== 'undefined') ? this.state.data.id : false;
    if(id === false) {
      console.log('Invalid ID');
      return;
    }
    if(this.state.data.state === 'Address') {
      if(id === 'add') {
        addAddress(this.state.data)
          .then((addr) => {
            if(addr['status'] === 'true') {
              this.setState({ Dialog: '', Addressloading: true, Address: [] });
              getAddress()
                .then((add) => {
                  if(add['status'] === 'true') {
                    this.setState({ Address: add['data'] });
                    this.setState({ Addressloading: false });
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
            }
            else if(addr['error'] !== '') {
              this.setState({ updateError: addr['error'] });
              if(typeof addr['fields'] !== 'undefined') {
                var dataError = this.state.dataError;
                addr['fields'].map((field) => {
                  dataError[field] = true;
                  return true;
                });
                this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
      }
      else {
        updateAddress(this.state.data, this.state.Address[this.state.data.id])
          .then((addr) => {
            if(addr['status'] === 'true') {
              this.setState({ Dialog: '', Addressloading: true, Address: [] });
              getAddress()
                .then((add) => {
                  if(add['status'] === 'true') {
                    this.setState({ Address: add['data'] });
                    this.setState({ Addressloading: false });
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
            }
            else if(addr['error'] !== '') {
              this.setState({ updateError: addr['error'] });
              if(typeof addr['fields'] !== 'undefined') {
                var dataError = this.state.dataError;
                addr['fields'].map((field) => {
                  dataError[field] = true;
                  return true;
                });
                this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
      }
    }
    else if(this.state.data.state === 'Team') {
      if(id === 'add') {
        addContact(this.state.data)
          .then((con) => {
            if(con['status'] === 'true') {
              this.setState({ Dialog: '',  Teamloading: true, Team: [] });
              getContact()
                .then((con) => {
                  if(con['status'] === 'true') {
                    this.setState({ Team: con['data'] });
                    this.setState({ Teamloading: false });
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
            }
            else if(con['error'] !== '') {
              this.setState({ updateError: con['error'] });
              if(typeof con['fields'] !== 'undefined') {
                var dataError = this.state.dataError;
                con['fields'].map((field) => {
                  dataError[field] = true;
                  return true;
                });
                this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
      }
      else {
        updateContact(this.state.data, this.state.Team[this.state.data.id])
          .then((con) => {
            if(con['status'] === 'true') {
              this.setState({ Dialog: '',  Teamloading: true, Team: [] });
              getContact()
                .then((con) => {
                  if(con['status'] === 'true') {
                    this.setState({ Team: con['data'] });
                    this.setState({ Teamloading: false });
                  }
                })
                .catch((error) => {
                  console.log(error);
                })
            }
            else {
              if(con['error'] !== '') {
                this.setState({ updateError: con['error'] });
                var dataError = this.state.dataError;
                con['fields'].map((field) => {
                  dataError[field] = true;
                  return true;
                });
                this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
      }
    }
  }
  handleClickDelete = () => {
    var id = (typeof this.state.data.id !== 'undefined') ? this.state.data.id : false;
    if(id === false) {
      console.log('Invalid ID');
      return;
    }
    if(this.state.data.state === 'Address') {
      deleteAddress(this.state.data)
        .then((addr) => {
          if(addr['status'] === 'true') {
            this.setState({ Dialog: '', Addressloading: true, Address: [] });
            getAddress()
              .then((add) => {
                if(add['status'] === 'true') {
                  this.setState({ Address: add['data'] });
                  this.setState({ Addressloading: false });
                }
              })
              .catch((error) => {
                console.log(error);
              })
          }
          else if(addr['error'] !== '') {
            this.setState({ updateError: addr['error'] });
            if(typeof addr['fields'] !== 'undefined') {
              var dataError = this.state.dataError;
              addr['fields'].map((field) => {
                dataError[field] = true;
                return true;
              });
              this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
    }
    else if(this.state.data.state === 'Team') {
      deleteContact(this.state.data)
        .then((con) => {
          if(con['status'] === 'true') {
            this.setState({ Dialog: '',  Teamloading: true, Team: [] });
            getContact()
              .then((con) => {
                if(con['status'] === 'true') {
                  this.setState({ Team: con['data'] });
                  this.setState({ Teamloading: false });
                }
              })
              .catch((error) => {
                console.log(error);
              })
          }
          else if(con['error'] !== '') {
            this.setState({ updateError: con['error'] });
            if(typeof con['fields'] !== 'undefined') {
              var dataError = this.state.dataError;
              con['fields'].map((field) => {
                dataError[field] = true;
                return true;
              });
              this.setState({ Dialog: this.buildProductDetail(this.state.data.state, id) });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

  render () {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>
            <FormattedMessage
              id='Account Details & Users'
              defaultMessage='Account Details & Users'
            />
          </font></center>
        </Typography>
        <p />
        <Paper style={{ padding: '25px' }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} style={{ textAlign: 'left' }}>
              <FormattedMessage
                id='Customer ID'
                defaultMessage='Customer ID'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['accid']}
              </span>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ textAlign: 'left' }}>
              <FormattedMessage
                id='Company Name'
                defaultMessage='Company Name'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['accname']}
              </span>
            </Grid>
            <p />
            <Grid item xs={12} sm={12} md={6} style={{ textAlign: 'left' }}>
              <FormattedMessage
                id='Account Manager'
                defaultMessage='Account Manager'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['rep']}
              </span><br />
              <FormattedMessage
                id='Phone Number'
                defaultMessage='Phone Number'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['repphone']}
              </span><br />
              <FormattedMessage
                id='Email Address'
                defaultMessage='Email Address'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['repemail']}
              </span>
            </Grid>
            <Grid item xs={11} sm={11} md={5} style={{ textAlign: 'left' }}>
              <FormattedMessage
                id='Carlson Dealer'
                defaultMessage='Carlson Dealer'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['dealer']}
              </span><br />
              <FormattedMessage
                id='Phone Number'
                defaultMessage='Phone Number'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['dealerphone']}
              </span><br />
              <FormattedMessage
                id='Email Address'
                defaultMessage='Email Address'
              />: <span style={{ color: 'gray' }}>
                {this.state.Account['dealeremail']}
              </span>
            </Grid>
            <Grid item xs={1} sm={1} md={1}>
              <Button
                variant="fab"
                mini
                onClick={() => this.handleDealerDialog(this.state.Account.dealerid)}
              >
                <Edit />
              </Button>
            </Grid>
            <p />&nbsp;
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'left', border: '1px silver solid', padding: '15px' }}>
              <Dialog
                open={(this.state.Dialog !== '')}
                onClose={this.handleCloseDialog}
              >
                <div>{this.state.Dialog}</div>
              </Dialog>
              <Typography variant="caption">
                <Button
                  color='primary'
                  style={{ textTransform: 'none' }}
                  onClick={this.handleOpenDialog('Address', 'add')}
                >
                  <AddBox />&nbsp;
                  <FormattedMessage
                    id='Add address'
                    defaultMessage='Add address'
                  />
                </Button>
                <FormattedMessage
                  id='Select a shipping and invoicing address from the list or create a new one'
                  defaultMessage='Select a shipping and invoicing address from the list or create a new one'
                />
              </Typography>
              <ReactTable
                columns={Tables['Address']}
                loading={this.state.Addressloading}
                data={this.state.Address}
                defaultPageSize={5}
                className="-striped -highlight"
                getTrProps={(state, rowInfo) => {
                  return {
                    onClick: (e) => {
                      this.ProductDetail('Address', rowInfo.index)
                    },
                    style: {
                      cursor: 'pointer'
                    }
                  }
                }}
              />
            </Grid>
            <p />&nbsp;
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'left', border: '1px silver solid', padding: '15px' }}>
              <Typography variant="caption">
                <Button
                  color='primary'
                  style={{ textTransform: 'none' }}
                  onClick={this.handleOpenDialog('Team', 'add')}
                >
                  <AddBox />&nbsp;
                  <FormattedMessage
                    id='Add new user'
                    defaultMessage='Add new user'
                  />
                </Button>
                <FormattedMessage
                  id='Select a Maintenance or Service user address from the list or create a new one'
                  defaultMessage='Select a Maintenance or Service user address from the list or create a new one'
                />
              </Typography>
              <ReactTable
                columns={Tables['Team']}
                loading={this.state.Teamloading}
                data={this.state.Team}
                defaultPageSize={5}
                className="-striped -highlight"
                getTrProps={(state, rowInfo) => {
                  return {
                    onClick: (e) => {
                      this.ProductDetail('Team', rowInfo.index)
                    },
                    style: {
                      cursor: 'pointer'
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </Paper>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.updateError !== ''}
          onClose={() => this.setState({ updateError: '' })}
          autoHideDuration={4000}
          message={
            <span style={{ color: 'red' }}>
              {this.state.updateError}
            </span>
          }
        />
      </div>
    );
  }
}

export default AccountDetailsTeam;



// WEBPACK FOOTER //
// ./src/components/home/AccountDetailsTeam.js